import * as actionTypes from '../actions/actionTypes';
import { getPortalNameForEligibilityScreen } from '../../shared/utility';
import { HSID_BASE, LOCKED, portal_with_portal_at_name_end, VERIFIED } from '../../shared/Constants';

const initialState = {
    selectMember: null,
    member: null,
    loading: false,
    message: null,
    memberEligMsg: null,
    rebuildCachePortal: null,
    deleteAccountMsg:null,
    deleteAccountStatus:false,
    updateCacheMsg:null,
    updateHsidInfoMsg:null,
    persInfoMsg: null,
    accountStatusProcessing: false,
    accountStatusMessage: null,
    spinnerProcessing: false,
    otpSpinnerProcessing: false,
    resetAccountMessage: null,
    resetAccountErrMessage: null,
    enableDisableStatusMsg: null,
    deleteEligMsg: null,
    processing: false,
    genTokenResponse: null,
    smsOtpMessage: null,
    bulkDisableResponse: null,
    bulkLockingResponse: null,
    bulkLdapUnlockResponse: null,
    bulkDisableErrorResponse: null,
    bulkLockingErrorResponse: null,
    bulkLdapUnlockErrorResponse: null,
    rebuildProcessing: false,
    sdkPortalList: null,
    disableReasons: [],
    getReasonFailure: null,
    impactedMemberData: null,
    accountSecurityToggle: false,
    incidentMembersList: [],
    disabledMember: null,
    otpGenerated: true,
    enableAttest: false,
    disableConfirm: false,
    passkeyList: [],
    passkeyProcessing: false,
    passkeyErrorMsg: ""
}

export const reducer = ( state = initialState, action ) => {
    switch (action.type) {
        case actionTypes.SELECT_MEMBER:
            return {
                ...state,
                selectedMember: action.selectedMember,
                loading: action.showLoader ?? true,
                deleteAccountMsg: null,
                deleteAccountStatus: false,
                accountStatusMessage: null,
                persInfoMsg: null,
                resetAccountMessage: null,
                resetAccountErrMessage: null,
                enableDisableStatusMsg: null,
                updateHsidInfoMsg: null,
                error: null,
            }
        case actionTypes.FETCH_MEMBER_DATA_SUCCESS:
            return {
                ...state,
                member: {
                    ...action.memberData,
                    ...(action.memberData?.essoData ? {essoData:JSON.parse(JSON.stringify(action.memberData?.essoData))}:{}),
                    mdmZip: action.memberData?.mdmZip?.substring(0,5)
                },
                loading: false,
                deleteAccountStatus: false,
                deleteAccountMsg: null,
                deleteEligMsg: null,
                smsOtpMessage: !action.persistSmsMessage ? null : state.smsOtpMessage,
                passkeyList: action.memberData?.essoData?.webAuthentications ?? [],
                error: null,
            }
        case actionTypes.FETCH_MEMBER_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                passkeyList: action.memberData?.essoData?.webAuthentications ?? [],
                error: {status: "FAILURE", message: "Sorry! You may select a member again!!"}
            }
        case actionTypes.RESET_MEMBER_ERROR:
            return {
                ...state,
                error: null
            }
        case actionTypes.REBUILD_CACHE_START:
            return {
                ...state,
                deleteEligMsg: null,
                memberEligMsg: null,
                rebuildProcessing: true,
                rebuildCachePortal: action.portalName
            }
        case actionTypes.REBUILD_CACHE_SUCCESS:
            return {
                ...state,
                rebuildProcessing: false,
                memberEligMsg: {type: "Success", message: "Rebuild cache for " + getPortalNameForEligibilityScreen(action.portalShortName) +" was successful!"},
                rebuildCachePortal: null
            }
        case actionTypes.REBUILD_CACHE_FAILURE:
            const message = "Sorry! Rebuild cache for  " + getPortalNameForEligibilityScreen(action.portalShortName) + " failed";
            const message2 = action.errorCode?" with "+action.errorCode+". Pls try again later.":". Pls try again.";
            return {
                ...state,
                rebuildProcessing: false,
                memberEligMsg: {type: "Failure", message: message.concat(message2)},
                rebuildCachePortal: null
            }
        case actionTypes.ADD_MEMBER_ELIGIBILITY:
            /* Commented to get rid of persisting the response directly
            const newMemberElig = action.memberElig;
            let memberElig = [...state.member.memberPortalAttributeList];
            let eligIndex = memberElig.findIndex(x => x.portalShortNm === newMemberElig.portalShortNm);

            if(newMemberElig.portalShortNm === "MYUHC"){
                let eligIndexoFmyUHC = -1;
                if(action.operation === "ADD"){
                    eligIndexoFmyUHC = memberElig.findIndex(x => x.portalPolicyNbr === newMemberElig.portalPolicyNbr);
                    let isPolicyExist = memberElig.filter(mE => mE.portalShortNm === "MYUHC").map(mE => mE.portalPolicyNbr).indexOf(newMemberElig.portalPolicyNbr);
                    if(isPolicyExist > -1){
                        memberElig[eligIndexoFmyUHC] = newMemberElig;
                    }else{
                        memberElig.push(newMemberElig);
                    }
                } else {
                    eligIndexoFmyUHC = memberElig.findIndex(x => x.memberPortalId === newMemberElig.memberPortalId);
                    memberElig[eligIndexoFmyUHC] = newMemberElig;
                }
            }else if(eligIndex > -1) {
                memberElig[eligIndex] = newMemberElig;
            } else {
                memberElig.push(newMemberElig);
            }*/
            return {
                ...state,
                member: {
                    ...state.member,
                    // memberPortalAttributeList: memberElig
                },
                memberEligMsg: action.operation && action.operation==="ADD"?{type: "Success", message: "Member Eligibility has been successfully added."}: {type: "Success", message: "Member Eligibility has been successfully updated."},
            }
        case actionTypes.DELETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                deleteAccountMsg: {type: "Success", message: "HSID has been deleted"},
                deleteAccountStatus:true,
                updateHsidInfoMsg:null
            }
        case actionTypes.DELETE_ACCOUNT_FAILURE:
            const delMessage = "Sorry! Delete Account failed";
            return {
                ...state,
                deleteAccountMsg: {type: "Failure", message: delMessage}
            }
        case actionTypes.UPDATE_CACHE_SUCCESS:
            return {
                ...state
                //updateCacheMsg: {type: "Success", message: "Update cache was successful"},
            }
        case actionTypes.UPDATE_CACHE_FAILURE:
            const updateCacheMessage = "Sorry! Update Cache for  " + action.uuid + " failed";
            return {
                ...state,
                updateCacheMsg: {type: "Failure", message: updateCacheMessage}
            }
        case actionTypes.UPDATE_HSID_INFO_SUCCESS:
            const response = action.response;
            let memberData = {};
            let updatedMember = response.data[0];
            memberData = {...state.member};
            memberData.mdmFirstNm = updatedMember.mdmFirstNm;
            memberData.mdmLastNm = updatedMember.mdmLastNm;
            memberData.mdmSubscriberId = updatedMember.mdmSubscriberId;
            memberData.mdmPolicyNbr = updatedMember.mdmPolicyNbr;
            memberData.mdmDob = updatedMember.mdmDob;
            memberData.mdmZip = updatedMember.mdmZip;
            return {
                ...state,
                member: memberData,
                updateHsidInfoMsg: {type: "Success", message: action.fieldsModified}
            }
        case actionTypes.UPDATE_HSID_INFO_FAILURE:
            return {
                ...state,
                updateHsidInfoMsg: {type: "Failure", message: action.fieldsModified.replace("updated"," failed to update")}
            }
        case actionTypes.PERSONAL_INFO_SUCCESS:
            let essoInfo = {};
            let updatedFields =[];

            const updatedInfo = action.personalInfo;
            const memResponse = action.response;
            essoInfo = {...state.member.essoData};
            if(memResponse.nameUpdationSuccess){
                if(essoInfo.firstName!==updatedInfo.firstName && essoInfo.lastName!==updatedInfo.lastName){
                    updatedFields.push("First and Last name have been updated");
                }else if(essoInfo.firstName!==updatedInfo.firstName){
                    updatedFields.push("First name has been updated");
                }else{
                    updatedFields.push("Last name has been updated");
                }
                essoInfo.firstName = updatedInfo.firstName;
                essoInfo.lastName = updatedInfo.lastName;
            }
            if(memResponse.dobUpdated){
                essoInfo.dob = updatedInfo.dob
                updatedFields.push("DOB has been updated");
            }
            if(memResponse.zipCodeUpdated){
                // assign updated zipcode to the essoInfo state
                updatedFields.push("ZipCode has been updated");
            }
            if(memResponse.isUserNameUpdated){
                essoInfo.userName = updatedInfo.userName
                updatedFields.push("Username update was successful!")
            }
            if(!essoInfo.email && (memResponse.emailUpdated || memResponse.emailVerified)){
                essoInfo['email'] = {value:updatedInfo.email, verified: true};
                updatedFields.push("Email is updated and Verified!")
            }
            else if(memResponse.emailUpdated || memResponse.emailVerified){
                if(memResponse.emailUpdated && memResponse.emailVerified){
                    essoInfo.email.value = updatedInfo.email;
                    essoInfo.email.verified = true;
                    updatedFields.push("Email is updated and Verified");
                }else if(memResponse.emailUpdated){
                    essoInfo.email.value = updatedInfo.email;
                    essoInfo.email.verified = false;
                    updatedFields.push("Email is Updated");
                }else{
                    essoInfo.email.verified = true;
                    updatedFields.push("Email is Verified");
                }
            }
            if(!essoInfo.secondaryEmail && (memResponse.secondaryEmailUpdated || memResponse.secondaryEmailVerified)){
                essoInfo['secondaryEmail'] = {value:updatedInfo.secondaryEmail, verified: true};
                updatedFields.push("Secondary Email is updated and Verified!")
            }
            else if(memResponse.secondaryEmailUpdated || memResponse.secondaryEmailVerified){
                if(memResponse.secondaryEmailUpdated && memResponse.secondaryEmailVerified){
                    essoInfo.secondaryEmail.value = updatedInfo.secondaryEmail;
                    essoInfo.secondaryEmail.verified = true;
                    updatedFields.push("Secondary Email is updated and Verified");
                }else if(memResponse.secondaryEmailUpdated){
                    essoInfo.secondaryEmail.value = updatedInfo.secondaryEmail;
                    essoInfo.secondaryEmail.verified = false;
                    updatedFields.push("Secondary Email is Updated");
                }else{
                    essoInfo.secondaryEmail.verified = true;
                    updatedFields.push("Secondary Email is Verified");
                }
            }
            if(memResponse.phoneUpdated || memResponse.phoneVerified){
                if(memResponse.phoneUpdated && memResponse.phoneVerified){
                    essoInfo.phone.number && essoInfo.phone.number!=null?updatedFields.push("Phone number is Updated and Verified"):updatedFields.push("Phone number is Added and Verified");
                    essoInfo.phone.number = updatedInfo.phoneNumber;
                    essoInfo.phone.countryCode = updatedInfo.countryCode;
                    essoInfo.phone.verified = true;
                } else if (memResponse.phoneUpdated) {
                    essoInfo.phone.number && essoInfo.phone.number!=null?updatedFields.push("Phone number is Updated"):updatedFields.push("Phone number is Added");
                    essoInfo.phone.number = updatedInfo.phoneNumber;
                    essoInfo.phone.countryCode = updatedInfo.countryCode;
                    essoInfo.phone.label = updatedInfo.phoneType === 'MOBILE' ? 'MOBILE' : 'NONMOBILE';
                    essoInfo.phone.verified = false;
                }else {
                    essoInfo.phone.verified = true;
                    updatedFields.push("Phone number is Verified");
                }  
                essoInfo.phone.label = updatedInfo.phoneType;  
            }
            const displayText = updatedFields.length>0?updatedFields.length===1?updatedFields.join(" "):updatedFields.join(", "): null;
            return {
                ...state,
                member: {
                    ...state.member,
                    essoData: essoInfo
                },
                persInfoMsg: {type: "Success", info: {message:displayText}},
                memResponse : memResponse
            }
        case actionTypes.UNLOCK_USER_START:
            return {
                ...state,
                accountStatusProcessing: true
            }
        case actionTypes.UNLOCK_USER_SUCCESS:
            return {
                ...state,
                accountStatusProcessing: false,
                member: {
                    ...state.member,
                    essoData: {
                        ...state.member.essoData,
                        essoStatus: {
                            ...state.member.essoData.essoStatus,
                            ldapLockStatus: "unlocked"
                        }
                    }
                },
                accountStatusMessage: {type: "Success", info: {message: action.message}}
            }
        case actionTypes.UNLOCK_USER_FAILURE:
            return {
                ...state,
                accountStatusProcessing: false,
                accountStatusMessage: {type: "Error", info: {message: action.error.description}}
            }
        case actionTypes.UNLOCK_RBA_START:
            return {
                ...state,
                accountStatusProcessing: true
            }
        case actionTypes.UNLOCK_RBA_SUCCESS:
            return {
                ...state,
                accountStatusProcessing: false,
                member: {
                    ...state.member,
                    essoData: {
                        ...state.member.essoData,
                        accountStatus: {
                            ...state.member.essoData,
                            aaStatus: VERIFIED
                        },
                        credential: {},
                    }
                },
                accountStatusMessage: {type: action.headlessUser?"Info":"Success", info: {message: action.message}}
            }
        case actionTypes.UNLOCK_RBA_FAILURE:
            return {
                ...state,
                accountStatusProcessing: false,
                accountStatusMessage: {type: "Error", info: {message: action.error.description}}
            }
        case actionTypes.ENABLE_DISABLE_ACCOUNT_START:
            return {
                ...state,
                accountStatusProcessing: true
            }
        case actionTypes.ENABLE_DISABLE_ACCOUNT_SUCCESS:
            const msg = "Successfully " + action.status+ " the account";
            return {
                ...state,
                accountStatusProcessing: false,
                enableDisableStatusMsg: {type: "Success", info: {message: msg}}
            }
        case actionTypes.ENABLE_DISABLE_ACCOUNT_FAILURE:
            return {
                ...state,
                accountStatusProcessing: false,
                enableDisableStatusMsg: {type: "Error", info: {message: action.error.errorMsg}}
            }
        case actionTypes.ENABLE_DISABLE_FAILURE:
            return {
                ...state,
                accountStatusProcessing: false,
                enableDisableStatusMsg: {type: "Error", info: {message: action.error}}
            }

        case actionTypes.RESET_ACCOUNT_START:
            return {
                ...state,
                spinnerProcessing: true
            }
        case actionTypes.RESET_PWD_SUCCESS:
            return {
                ...state,
                resetAccountMessage: {type: "Success", info: {message: action.message}},
                spinnerProcessing: false
            }
        case actionTypes.RESET_PWD_FAILURE:
            return {
                ...state,
                resetAccountMessage: {type: "Error", info: {message: action.error.description}},
                spinnerProcessing: false
            }
        case actionTypes.RESET_SQ_SUCCESS:
            let essoDataSQ = {...state.member.essoData};
            essoDataSQ.credential = {};
            essoDataSQ.phone.number = "";
            essoDataSQ.phone.verified = false;
            essoDataSQ.phone.label = "";
            return {
                ...state,
                member: {
                    ...state.member,
                    essoData: essoDataSQ
                },
                resetAccountMessage: {type: action.code==="INFO"?"Info":"Success", info: {message: action.message}},
                spinnerProcessing: false
            }
        case actionTypes.RESET_SQ_FAILURE:
            return {
                ...state,
                resetAccountErrMessage: {type: "Error", info: {message: action.error.errorDesc}},
                spinnerProcessing: false
            }
        case actionTypes.VERIFY_EMAILPHONE_SUCCESS:
            let essoVerify = {...state.member.essoData};
            if(action.message === "Phone Verified Successfully"){
                essoVerify.phone.verified = true;                
            }else if(action.message === "Email Verified Successfully"){
                essoVerify.email.verified = true;
            }else if(action.message === "Secondary Email Verified Successfully"){
                essoVerify.secondaryEmail.verified = true;
            }
            return {
                ...state,
                member: {
                    ...state.member,
                    essoData: essoVerify
                },
                persInfoMsg: {type: "Success", info: {message: action.message}},
                spinnerProcessing: false
            }
        case actionTypes.VERIFY_EMAILPHONE_FAILURE:
            return {
                ...state,
                persInfoMsg: {type: "Error", info: {message: action.error}},
                spinnerProcessing: false
            }
        case actionTypes.DELETEPHONE_SUCCESS:
            let essoDataDP = {...state.member.essoData};
            essoDataDP.credential = {};
            essoDataDP.phone.number = "";
            essoDataDP.phone.verified = false;
            essoDataDP.phone.label = "";
            return {
                ...state,
                member: {
                    ...state.member,
                    essoData: essoDataDP 
                },
                persInfoMsg: {type: action.code==="INFO"?"Info":"Success", info: {message: action.message}},
                spinnerProcessing: false
            }
        case actionTypes.DELETEPHONE_FAILURE:
            return {
                ...state,
                persInfoMsg: {type: "Error", info: {message: action.error}},
                spinnerProcessing: false
            }
        case actionTypes.DELETE_SECONDARY_EMAIL_SUCCESS:
            let essoData = {...state.member.essoData};
            delete essoData.secondaryEmail
            return {
                ...state,
                member: {
                    ...state.member,
                    essoData:essoData
                },
                persInfoMsg: {type: action.code==="INFO"?"Info":"Success", info: {message: action.message}},
                spinnerProcessing: false
            }

        case actionTypes.DELETE_SECONDARY_EMAIL_FAILURE:
            return {
                ...state,
                persInfoMsg:{type:"Error", info: {message: action.error}},
                spinnerProcessing: false
            }
            case actionTypes.INITIATE_ATTEST_SUCCESS:
            return {
                ...state,
                enableAttest: true
            }
            case actionTypes.INITIATE_ATTEST_FAILURE:
            return {
                ...state,
                enableAttest: false
            }
        case actionTypes.SMS_OTP_TOKEN_START:
            return {
                ...state,
                otpSpinnerProcessing: true
            }
        case actionTypes.SMS_OTP_TOKEN_STOP:
            return {
                ...state,
                otpSpinnerProcessing: false
            }
        case actionTypes.SMS_OTP_TOKEN_SUCCESS:
            return {
                ...state,
                otpSpinnerProcessing: false,
                genTokenResponse: action.genTokenResponse,
                disableConfirm: false,
                smsOtpMessage: {type: "Success", info: {message: action.otpType === 'Phone' ? "Passcode Sent" : "Passcode Call Initiated"}},
            }
        case actionTypes.SMS_OTP_TOKEN_FAILURE:
            return {
                ...state,
                otpSpinnerProcessing: false,
                smsOtpMessage: {type: "Error", info: {message: action.error}}
            }
        case actionTypes.VERIFY_OTP_TOKEN_SUCCESS:
            return {
                ...state,
                persInfoMsg: null,
                otpSpinnerProcessing: false,
                smsOtpMessage: {type: "Success", info: {message: action.message}}
            }
        case actionTypes.VERIFY_OTP_TOKEN_FAILURE:
            return {
                ...state,
                otpSpinnerProcessing: false,
                smsOtpMessage: {type: "Error", info: {message: action.error}}
            }
        case actionTypes.VERIFY_OTP_TOKEN_LOCKED:
            return {
                ...state,
                member: {
                    ...state.member,
                    essoData: {
                        ...state.member.essoData,
                        accountStatus: {
                            ...state.member.essoData,
                            aaStatus: LOCKED
                        }
                    }
                },
                disableConfirm: true,
                otpSpinnerProcessing: false,
                smsOtpMessage: {type: "Error", info: {message: action.error}}
            }
        case actionTypes.SET_OTP_DISPLAY_MESSAGE:
            return {
                ...state,
                smsOtpMessage: action.message,
            }
        case actionTypes.DELETE_ELIGIBILITY_START:
            return {
                ...state,
                processing: true,
                message: null,
                showModal: false,
                modifyDetails: true
            }
        case actionTypes.DELETE_ELIGIBILITY_SUCCESS:
            let memberEligPrtlList = [...state.member.memberPortalAttributeList];
            const displMessage = portal_with_portal_at_name_end.includes(action.portalShortNm) ? " record deleted successfully." : " portal record deleted successfully.";
            return {
                ...state,
                processing: false,
                member: {
                    ...state.member,
                    memberPortalAttributeList: memberEligPrtlList.filter(memberEligPrtlList => memberEligPrtlList.memberPortalId !== action.memberPortalId)
                },
                deleteEligMsg: {type: "Success", message:  getPortalNameForEligibilityScreen(action.portalShortNm)  + displMessage}
            }
        case actionTypes.DELETE_ELIGIBILITY_FAILURE:
            return {
                ...state,
                processing: false,
                deleteEligMsg: {type: "Failure", message: "Deletion failure for " + getPortalNameForEligibilityScreen(action.portalShortNm) + " portal record."}
            }
        case actionTypes.SET_DEL_ELIG_MESSAGE:
            return {
                ...state,
                deleteEligMsg: null,
                memberEligMsg: null
            }
        case actionTypes.BULK_USER_ACTIVITY_START:
            return {
                ...state,
                spinnerProcessing: true
            }
        case actionTypes.BULK_USER_ACTIVITY_STOP:
            return {
                ...state,
                spinnerProcessing: false
            }
        case actionTypes.BULK_DISABLE_SUCCESS:
            return {
                ...state,
                spinnerProcessing: false,
                bulkDisableResponse: action.bulkDisableResponse,
            }
        case actionTypes.BULK_DISABLE_FAILURE:
            return {
                ...state,
                spinnerProcessing: false,
                bulkDisableErrorResponse: action.error
            }
        case actionTypes.BULK_LOCKING_SUCCESS:
            return {
                ...state,
                spinnerProcessing: false,
                bulkLockingResponse: action.bulkLockingResponse,
            }
        case actionTypes.BULK_LOCKING_FAILURE:
            return {
                ...state,
                spinnerProcessing: false,
                bulkLockingErrorResponse: action.error
            }
        case actionTypes.BULK_LDAP_UNLOCK_SUCCESS:
            return {
                ...state,
                spinnerProcessing: false,
                bulkLdapUnlockResponse: action.bulkLdapUnlockResponse,
            }
        case actionTypes.BULK_LDAP_UNLOCK_FAILURE:
            return {
                ...state,
                spinnerProcessing: false,
                bulkLdapUnlockErrorResponse: action.error
            }
        case actionTypes.BULK_DELETE_SUCCESS:
            return {
                ...state,
                spinnerProcessing: false,
                bulkDeleteResponse: action.bulkDeleteResponse,
            }
        case actionTypes.BULK_DELETE_FAILURE:
            return {
                ...state,
                spinnerProcessing: false,
                bulkDeleteErrorResponse: action.error
            }
        case actionTypes.BULK_EIMP_SYNC_SUCCESS:
            return {
                ...state,
                spinnerProcessing: false,
                bulkEimpSyncResponse: action.bulkEimpSyncResponse,
            }
        case actionTypes.BULK_EIMP_SYNC_FAILURE:
            return {
                ...state,
                spinnerProcessing: false,
                bulkEimpSyncErrorResponse: action.error
            }
        case actionTypes.SET_BULKDISABLE_RESP_EMPTY:
            return {
                ...state,
                bulkDisableResponse: null,
                bulkLockingResponse: null,
                bulkDisableErrorResponse: null,
                bulkLockingErrorResponse: null,
                bulkLdapUnlockResponse: null,
                bulkLdapUnlockErrorResponse: null
            }
        case actionTypes.FETCH_PORTAL_CONFIG_SUCCESS:
            return{
                ...state,
                sdkPortalList: action.sdkPortalList

            }
        case actionTypes.FETCH_PORTAL_CONFIG_FAILURE:
            return{
                ...state,
                sdkPortalList: []
            }
        case actionTypes.RESET_MEMRESPONSE:
            return{
                ...state,
                memResponse: {}
            }
        case actionTypes.SET_BULKDISABLE_RSN:
            return{
                ...state,
                disableReasons: action.rsnList
            }
        case actionTypes.SET_FEATURE_RSN:
            return{
                ...state,
                [action.feature]: action.rsnList
            }
        case actionTypes.GET_REASON_FAILURE:
            return{
                ...state,
                getReasonFailure: action.response
            }
        case actionTypes.FETCH_IMPACTED_MEMBER_DATA_SUCCESS:
            return{
                ...state,
                loading: false,
                impactedMemberData: action.impactedMemberData
            }
        case actionTypes.SET_ACCOUNT_SECURITY_TOGGLE:
            return{
                ...state,
                accountSecurityToggle: action.toggleState
            }
        case actionTypes.SET_INCIDENT_MEMBERS_LIST:
            return {
                ...state,
                incidentMembersList: [...state.incidentMembersList, ...action.incidentMembersList]
            }
        case actionTypes.RESET_INCIDENT_MEMBERS_LIST:
            return {
                ...state,
                incidentMembersList: [...action.incidentMembersList]
            }
        case actionTypes.SET_DISABLED_MEMBER_STATUS:
            return {
                ...state,
                disabledMember: action.payload
            }
        case actionTypes.ERASE_ACCOUNT_SECURITY_REDUCERS:
            return {
                ...state,
                // loading: false,
                impactedMemberData: null,
                accountSecurityToggle: false,
                incidentMembersList: [],
                disabledMember: null
            }
        case actionTypes.CLEAR_ENABLE_DISABLE_MSG:
            return{
                ...state,
                enableDisableStatusMsg: null

            }
        case actionTypes.OTP_GENERATED_FLAG:
            return {
                ...state,
                otpGenerated: action.flag
            }
        case actionTypes.PASSKEY_LOADING:
            return {
                ...state,
                passkeyProcessing: true,
            }
        case actionTypes.FETCH_PASSKEY_LIST_SUCCESS:
            return {
                ...state,
                passkeyList: action.passkeyList,
                passkeyErrorMsg: "",
            }
        case actionTypes.FETCH_PASSKEY_LIST_FAILURE:
            return {
                ...state,
                passkeyList: action.passkeyList,
                passkeyErrorMsg: "",
            }
        case actionTypes.PASSKEY_TOGGLE_SUCCESS:
            return {
                ...state,
                passkeyList: [...action.passkeyList],
                passkeyProcessing: false,
                passkeyErrorMsg: "",
            }
        case actionTypes.PASSKEY_TOGGLE_FAILURE:
            return {
                ...state,
                passkeyProcessing: false,
                passkeyErrorMsg: "Failed to update the passkey status. Please try again."
            }
        case actionTypes.PASSKEY_DELETE_SUCCESS:
            return {
                ...state,
                passkeyList: [...action.passkeyList],
                passkeyProcessing: false,
                passkeyErrorMsg: "",
            }
        case actionTypes.PASSKEY_DELETE_FAILURE:
            return {
                ...state,
                passkeyProcessing: false,
                passkeyErrorMsg: "Failed to delete the passkey. Please try again."
            }
        default:
            return state;
    }
}

export default reducer;